<template>
  <v-card :class="getCardClass()" :style="`width:${width ? width : null}`">
    <v-list-item
      :style="`padding: 2%;`"
    >
      <v-list-item-avatar :size="avatarSize ? avatarSize : '70'">
        <v-img :src="avatar"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>
          <span
            style="font-size: 15px"
            class="font-weight-bold defaultColor--text mb-0"
          >
            {{ fullName }}
            /
          </span>
          <span style="font-size: 15px" class="defaultColor--text mb-0">
            <!-- <departmant-icon :departmentName="department" /> -->
            {{ department }}
          </span>
        </v-list-item-title>

        <v-list-item-subtitle class="mt-1">
          <span style="font-size: 15px" class="defaultColor--text mr-2">{{
            division
          }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="buttonVisible">
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize mr-2 elevation-0"
          rounded
          small
          :text="buttonTypeText"
          :disabled="buttonDisabled"
          @click="$emit('sendMessage', item)"
        >
          {{ this.buttonText }}
        </v-btn>
      </v-list-item-action>

      <v-list-item-action v-if="star">
        <v-rating
          v-model="star"
          :length="star"
          readonly
          color="defaultColor"
          small
        ></v-rating>
      </v-list-item-action>
    </v-list-item>

    <v-divider v-if="divider" />
  </v-card>
</template>

<script>
import DepartmantIcon from "../General/DepartmantIcon.vue";

export default {
  data() {
    return {};
  },
  props: {
    item: Object,
    buttonText: String,
    buttonDisabled: Boolean,
    buttonVisible: {
      type: Boolean,
      default: false,
    },
    avatar: String,
    fullName: String,
    department: String,
    division: String,
    company: String,
    noBg: Boolean,
    divider: Boolean,
    star: Number,
    width: String,
    avatarSize: String,
    buttonTypeText: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DepartmantIcon,
  },
  mounted() {},
  methods: {
    getCardClass() {
      if (this.noBg) {
        return "noBgCard";
      } else {
        return "mx-3 defaultCardClass mb-5";
      }
    },
  },
  computed: {},
};
</script>

<style>
.noBgCard {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0px solid red !important;
  box-shadow: none !important;
}
</style>
